import React from "react";
import AdminDashboard from "./components/AdminDashboard";
import SellerDashboard from "./components/SellerDashboard";
import BuyerDashboard from "./components/BuyerDashboard";
import ProfessionalDashboard from "./components/ProfessionalDashboard";

const Dashboard = () => {
  const userData = JSON.parse(sessionStorage.getItem("userDetails"))?.result;

  return (
    <div>
      {userData?.role?.id === 2 ? (
        <AdminDashboard />
      ) : userData?.loggedinprofiletype === "buyerprofile" ? (
        <BuyerDashboard />
      ) : userData?.loggedinprofiletype === "sellerprofile" ? (
        <SellerDashboard />
      ) : (
        <ProfessionalDashboard />
      )}
    </div>
  );
};

export default Dashboard;
